import { computed } from 'vue'
import { useJobFormStore } from '@/components/Job/Edit/store/jobFormStore'
import { Association, JobEndTimeframe, JobStartTimeframe } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const getStartDateText = (store) => {
  switch (store.form.startDateTimeframe) {
    case JobStartTimeframe.Asap:
      return $t('As soon as possible')
    case JobStartTimeframe.NextMonth:
      return $t('within a month')
    case JobStartTimeframe.OnDate:
      return `${$t('on')} ${store.form.startDate ?? $t('a specific date')}`
    default:
      return ''
  }
}

const getCommitmentText = (store) => {
  switch (store.form.commitment) {
    case Association.FullTime:
      return $t('working Full-Time')
    case Association.PartTime:
      return $t('working Part-Time')
    case Association.Project:
    case Association.BigProject:
      return $t('working on a project')
    case Association.SmallTask:
      return $t('working on a small task')
    default:
      return $t('working')
  }
}

const getLengthText = (store) => {
  switch (store.form.endDateTimeframe) {
    case JobEndTimeframe.OneMonth:
      return $t('for 1 month')
    case JobEndTimeframe.ThreeMonths:
      return $t('for 3 months')
    case JobEndTimeframe.SixMonths:
      return $t('for 6 months')
    case JobEndTimeframe.Open:
      return $t('for an unspecified amount of time')
    case JobEndTimeframe.OnDate:
      return `${$t('until')} ${store.form.endDate ?? $t('a specific date')}`
    default:
      return ''
  }
}

const getOptionToExtendText = (store) =>
  store.form.isExtensionAvailable ? ` ${$t('with option to extend')}` : ''

export default function useGetSummaryText() {
  const store = useJobFormStore()
  return computed(
    () =>
      `“${$t('Applicants should be available to start')} ${getStartDateText(
        store,
      )} ${getCommitmentText(store)} ${getLengthText(store)}${getOptionToExtendText(store)}”`,
  )
}
